import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-markercluster";
import { Card, CardBody, Col } from "reactstrap";
 import L, { LatLngExpression } from "leaflet";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import { baseOrganizations } from "../../../data/dashboard/ChartData";
import CardHeaderCommon from "../../../common-elements/card-header-common/CardHeaderCommon";

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const organizationLocations = [
  ...baseOrganizations,
  ...Array.from({ length: 200 }, (_, i) => {
    const base = baseOrganizations[i % baseOrganizations.length];
    const [baseLat, baseLng] = base.position as [number, number];
    const latOffset = ((i % 10) - 5) * 0.05;
    const lngOffset = ((i % 7) - 3) * 0.05;
    return {
      id: `ORG${21 + i}`,
      name: `${base.name} Branch ${i + 1}`,
      position: [baseLat + latOffset, baseLng + lngOffset] as LatLngExpression,
      country: base.country,
    };
  }),
];

const worldCenter: LatLngExpression = [20, 0];

const OrganizationByCountry = () => {
  return (
    <Col lg="12" className="m-0">
      <Card>
        <CardHeaderCommon title="Organization Heat Map" />
        <CardBody>
          <MapContainer
            style={{ height: 311 }}
            easeLinearity={0.35}
            attributionControl={true}
            center={worldCenter}
            zoom={2}
            scrollWheelZoom={true}
            className="z-0 jvector-map-height"
          >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <MarkerClusterGroup>
              {organizationLocations.map((org) => (
                <Marker key={org.id} position={org.position}>
                  <Popup>
                    <strong>{org.name}</strong> <br /> {org.country}
                  </Popup>
                </Marker>
              ))}
            </MarkerClusterGroup>
          </MapContainer>
        </CardBody>
      </Card>
    </Col>
  );
};

export default OrganizationByCountry;
